<template lang="pug">
.check-in-item(
  :class="{ lottie: lottie, checked: item.checked && !lottie}"
)
  template(v-if="lottie")
    lottie.lottie(:url="json")
  .name {{ item.text || '第1天' }}
  template(v-if="lottie")
    .placeholder
  template(v-else)
    img.icon(:class="item.class")(:src="item.icon")
  .amount {{ item.amount || '0.01' }}
</template>

<script>
import Lottie from '@/components/lottie';

export default {
  components: {
    Lottie,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    lottie: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      json: 'https://m.hellobike.com/resource/AppPlatformH5/fuli/g7aBjLGCeACNMniT0ukVZ.json',
    };
  },
};
</script>
<style scoped lang="less">
.check-in-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 0.54rem;
  height: 0.7rem;
  background: #f7f6f5;
  padding: 0.06rem 0;
  border-radius: 0.07rem;
  position: relative;

  .lottie {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  &:not(:last-of-type) {
    margin-right: 0.13rem;
  }

  .name {
    font-size: 0.12rem;
    color: #879099;
    z-index: 10;
  }

  .placeholder {
    display: block;
    height: 0.24rem;
    width: 0.24rem;
    visibility: hidden;
    z-index: 10;
  }

  .icon {
    display: flex;
    width: 0.24rem;
    height: 0.24rem;
    z-index: 10;

    &.red {
      width: 0.18rem;
      height: 0.23rem;
    }
  }

  .amount {
    font-size: 0.14rem;
    color: #879099;
    z-index: 10;
  }

  &.checked {
    background: linear-gradient(137deg, #ff8e67 0%, #ff5103 100%);

    .name {
      color: #fff;
    }

    .amount {
      color: #fff;
    }
  }

  &.lottie {
    background: transparent;

    .name {
      color: #fff;
    }

    .amount {
      color: #fff;
    }
  }
}
</style>
